
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationMessageComponent } from "../../../../shared/components/validation-message/validation-message.component";
import { serviceData } from '../../../../data/DCGJProcess';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { SharedService } from '../../../../shared/services/shared.service';
import { serviceDataArabic } from '../../../../data/DCGJProcessArabic';
import { CurrencyPipe } from '../../../../shared/pipes/currency.pipe';
import { Subject, takeUntil } from 'rxjs';
interface Step {
  HEAD: string;
  DESC: string;
}
@Component({
  selector: 'app-service-detail',
  imports: [TranslateModule, ButtonComponent, ValidationMessageComponent],
  templateUrl: './service-detail.component.html',
  styleUrl: './service-detail.component.scss'
})
export class ServiceDetailComponent implements OnInit, OnDestroy {
  steps: any[] = [];
  service: any | null = null;
  lang: string = 'en';
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService
  ) {
    this.lang = this.sharedService.getCurrentLang() || "en";
    /*  Grab the full steps array from translation file
        once during construction.  You can also use
        translate.stream(…) if you expect language switch. */

  }
  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const id = params.get('id');
      this.setServiceById(id);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setServiceById(id: string | null): void {
    if (id) {
      if (this.lang == 'ar') {
        this.service = (serviceDataArabic.Items || []).find((i: any) => i.id === id) || null;
      } else {
        this.service = (serviceData.Items || []).find((i: any) => i.id === id) || null;
      }
      this.serviceData = "";
      this.loadServiceData();
    } else {
      this.service = null;
    }
  }

  // This method is used to service name
  get serviceName(): string {
    const sr = this.service?.SRType ?? '';
    const parts = String(sr).split('||');
    if (parts.length > 1) return (parts[1] || '').trim();
    return (sr || '').trim();
  }

  // This method is used to service group
  get serviceGroup(): string {
    const sr = this.service?.SRType ?? '';
    const parts = String(sr).split('||');
    return (parts[0] || '').trim();
  }

  // This method is used to pre content
  get preContent(): string {
    return this.service?.PreContent || '';
  }

  // This method is used to pre text
  get preText(): string {
    return this.service?.PreText || '';
  }

  // Dynamic steps sourced from selected service's Stages
  get serviceStages(): any[] {
    const stages = (this.service?.Stages || []) as any[];
    return [...stages].sort((a, b) => Number(a?.Position ?? 0) - Number(b?.Position ?? 0));
  }

  // This method is used to start service
  startService(): void {
    const id = this.service?.id;
    if (!id) return;
    if (!this.sharedService.isServiceAllowed(this.service)) {
      this.sharedService.toastMessage('ERROR', 'SERVICE_NOT_AUTHORIZED', 'error');
      return;
    }
    this.router.navigate([RoutesPath.SERVICE + '/' + id]);
  }

  serviceData: any;
  serviceDescription = "";
  processingTime = "";
  feesNote = "";
  serviceProcedure = [];
  beneficiaries = [];
  requirements: any = {};
  serviceFees = [];
  additionalInformation: any = {};
  howToApply = [];
  resources = [];

  get requirementSections(): any[] {
    const requirements = this.serviceData?.serviceRequirements;
    return requirements ? [requirements, ...(requirements.additionalSections ?? [])] : [];
  }

  loadServiceData() {
    this.serviceData = this.service; //serviceData.Items[0];

    this.serviceDescription = this.serviceData.serviceDetail?.description;
    this.processingTime = this.serviceData.serviceDetail?.processingTime;
    this.feesNote = this.serviceData.serviceDetail?.feesNote;

    this.serviceProcedure = this.serviceData.serviceProcedure ?? [];
    this.beneficiaries = this.serviceData.Beneficiaries ?? [];
    this.requirements = this.serviceData.serviceRequirements ?? {};
    this.serviceFees = this.serviceData.serviceFees ?? [];
    this.additionalInformation = this.serviceData.additionalInformation ?? {};
    this.howToApply = this.serviceData.howToApply ?? [];
    this.resources = this.serviceData.resources ?? [];
  }
  gotoServiceManuals() {
   this.sharedService.downloadServiceManual();
  }
}
